// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"612fc3d2","931":"6bc2e3d9"}[chunkId] + ".chunk.css";
};